import AlertModal from '../AlertModal';
import i18n from '../../helpers/i18n';

export default function MultipleDevicesCreatedAlert({ isOpen, devicesLenght, onCreated }) {
    return (
        <AlertModal
            title={i18n.t(`modal.multipleDevicesCreated.title${devicesLenght === 1 ? '' : '_plural'}`, { count: devicesLenght })}
            buttonText={i18n.t('modal.multipleDevicesCreated.buttonText')}
            children={i18n.t(`modal.multipleDevicesCreated.message${devicesLenght === 1 ? '' : '_plural'}`, { count: devicesLenght })}
            buttonAction={onCreated}
            visible={isOpen} />
    )
}